<template>
<div class="OrderIndex">
    <div class="warp">
        <p class="order_info_text">订单信息</p>
        <div class="order_info_box">
            <p class="p_title">订单详情</p>
            <div class="table_box">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="name" :label="name" align="center" min-width="100">
                        <template slot-scope="scope">
                            <div class="table_course_name_box">
                                <img :src="scope.row.coverurl" alt="">
                                <span>{{scope.row.subject}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="coursetypetext" :label="type" align="center"></el-table-column>
                    <el-table-column :label="price" align="center">
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.uprice !== '0.00'">￥{{scope.row.uprice}}</span>
                                <span v-else>--</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="saleprice" :label="nowPrice" align="center">
                        <template slot-scope="scope">￥{{scope.row.saleprice}}</template>
                    </el-table-column>
                </el-table>
            </div>
            <p class="p_title" v-if="tableData[0].couponvoucherlist && tableData[0].couponvoucherlist.length">优惠券</p>
            <el-tabs type="border-card" class="couponCode" v-if="tableData[0].couponvoucherlist && tableData[0].couponvoucherlist.length">
                <el-tab-pane label="优惠券">
                    <div class="content">
                        <div class="item" @click="changeCoupon(index)" :class="{'active': index === selectCouponIndex}" v-for="(item, index) in tableData[0].couponvoucherlist" :key="index">
                            <div class="faceprice_preferContent">
                                <div class="faceprice">
                                    <span v-if="item.voucherdistype === 1">
                                        <span class="unit">￥</span>
                                        <span class="faceprice">{{item.faceprice}}</span>
                                    </span>
                                    <span v-if="item.voucherdistype === 2">
                                        <span class="voucherdisrate">{{item.voucherdisrate}}</span>
                                        <span class="unit">折</span>
                                    </span>
                                </div>
                                <div class="preferContent">{{item.prefercontent}}</div>
                            </div>
                            <div class="date">
                                有效期：{{item.datetime}}
                            </div>
                            <img class="select" v-if="index === selectCouponIndex" :src="require('@/common/images/other/select.png')" alt="">
                        </div>
                    </div>
                </el-tab-pane>
                <!-- <el-tab-pane label="兑换码">
                    <div class="code">
                        <el-input></el-input>
                        <el-button type="primary">兑换</el-button>
                    </div>
                </el-tab-pane> -->
            </el-tabs>
        </div>
        <div class="order_info_box">
            <p class="p_title">订单金额</p>
            <p class="pay_text coupon" v-if="tableData[0].uprice > 0">商品原价：<span>￥{{tableData[0].uprice}}</span></p>
            <p class="pay_text coupon">商品现价：<span>￥{{tableData[0].saleprice}}</span></p>
            <p class="pay_text coupon" v-if="tableData[0].islimitcount">限时折扣：<span>￥{{tableData[0].limitprice}}</span></p>
            <p class="pay_text coupon" v-if="tableData[0].isplusprice">PLUS价：<span>￥{{tableData[0].plusprice}}</span></p>
            <p class="pay_text coupon" v-if="selectCouponIndex !== -1">优惠券：<span>-￥{{discountPrice}}</span></p>
            <p class="pay_text">实际支付：<span>¥{{saleprice}}</span></p>
            <p class="exchange_tips" v-if="kmctype==7 || kmctype==3 || kmctype==2 || kmctype==8" @click="exchangeDialog = true">我有兑换码，点击兑换>></p>
            <div class="submit_order_box">
                <el-button @click="submitOrder" type="primary" style="width: 160px;">提交订单</el-button>
                <div class="agreementBox">
                    <el-checkbox v-model="agreement"></el-checkbox>
                    勾选即表示同意 <a target="_blank" href="http://www.capwhale.com/index/payTerms.html">《快捷支付服务协议》</a> <a target="_blank" href="http://www.capwhale.com/index/payUserTerms.html">《微信支付用户服务协议》</a>
                </div>
            </div>
        </div>
    </div>
    <FormDialog ref="formDialog" @fillInOver="fillInOver" />
    <el-dialog class="exchangeDialog" title="兑换码" :visible.sync="exchangeDialog" width="400px" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-input placeholder="请输入兑换码" v-model="codevalue"></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button @click="exchangeDialog = false;codevalue = '';">取 消</el-button>
            <el-button type="primary" @click="uploadRedeemcodeInfo">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {getOrderDetail, uploadPayOrder, getPayResultInfo} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import {uploadRedeemcodeInfo} from 'api/personalCenterApi'
import FormDialog from '../components/formDialog'
//20210826改成统一的入口参数
export default {
    name: 'OrderIndex',
    data() {
        return {
            tableData: [
                {
                    saleprice: ''
                }
            ],
            // name:this.$route.query.kmctype===8?'题库名称':'课程名称',
            // type:this.$route.query.kmctype===8?'题库类型':'课程类型',
            // price:this.$route.query.kmctype===8?'题库原价':'课程原价',
            // nowPrice:this.$route.query.kmctype===8?'题库现价':'课程现价',
            name:this.$route.query.kmctype==8?'题库名称':(this.$route.query.kmctype==2?'报告名称':(this.$route.query.kmctype==3?'直播名称':'课程名称')),
            type:this.$route.query.kmctype==8?'题库类型':(this.$route.query.kmctype==2?'报告类型':(this.$route.query.kmctype==3?'直播类型':'课程类型')),
            price:this.$route.query.kmctype==8?'题库原价':(this.$route.query.kmctype==2?'报告原价':(this.$route.query.kmctype==3?'直播原价':'课程原价')),
            nowPrice:this.$route.query.kmctype==8?'题库现价':(this.$route.query.kmctype==2?'报告现价':(this.$route.query.kmctype==3?'直播现价':'课程现价')),
            selectCouponIndex: 0,
            discountPrice: '',
            saleprice: '',
            fillInForm: false,
            fillInArr: [],
            exchangeDialog: false,
            codevalue: '',
            // courseid: this.$route.query.kmctype==8?this.$route.query.qid:(this.$route.query.kmctype==2?this.$route.query.reportid:(this.$route.query.kmctype==3?this.$route.query.liveid:this.$route.query.cid)),
            agreement: false,
            kmctype:this.$route.query.kmctype?this.$route.query.kmctype:7,
            kmcinnerid:this.$route.query.kmcinnerid?this.$route.query.kmcinnerid:'',
        }
    },
    mounted() {
        this.findOrderDetail()
    },
    methods: {
        uploadRedeemcodeInfo() {
            if (this.codevalue) {
                this.setLoading(true)
                // let kmcinnerid = this.$route.query.kmctype==8?this.$route.query.qid:(this.$route.query.kmctype==2?this.$route.query.reportid:this.$route.query.cid)
                // let kmctype = this.$route.query.kmctype==8?8:(this.$route.query.kmctype==2?2:7)
                let kmcinnerid = this.kmcinnerid
                let kmctype = this.kmctype
                uploadRedeemcodeInfo({
                    data: {kmcinnerid, kmctype, ordermoney: this.tableData[0].finalpayprice, redeemcodevalue: this.codevalue},
                    success: () => {
                        this.setLoading(false)
                        this.$message.success('兑换成功')
                        // 题库
                        setTimeout(() => {
                            this.exchangeDialog = false
                            this.codevalue = ''
                            // this.setRefresh(true)
                            if (kmctype === 8 || kmctype === '8') {
                                this.$router.push({name: 'QuestionDetails', query: {qid: this.kmcinnerid}})
                            } else if(kmctype === 2 || kmctype === '2'){ //报告
                                this.$router.push({name: 'ReportDetails', query: {reportid: this.kmcinnerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                            } else if (kmctype === 3 || kmctype === '3') { // 直播
                                this.$router.push({name: 'VideoLiveing', query: {innerid: this.kmcinnerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                            }else{ //课程
                                this.$router.push({name: 'CourseDetails', query: {cid: this.kmcinnerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                            }
                        }, 1000)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                })
            } else {
                this.$message.warning('请输入兑换码')
            }
        },
        fillInOver(arr) {
            this.fillInArr = arr
            this.fillInForm = true
            this.submitOrder()
            // console.log(arr)
        },
        changeCoupon(index) {
            // console.log(index, this.selectCouponIndex)
            if (index !== this.selectCouponIndex) {
                this.selectCouponIndex = index
                this.discountPrice = this.tableData[0].couponvoucherlist[this.selectCouponIndex].discountmoney
                this.saleprice = this.tableData[0].couponvoucherlist[this.selectCouponIndex].ordermoney
            } else {
                this.selectCouponIndex = -1
                this.saleprice = this.tableData[0].finalpayprice
            }
        },
        // 获取订单信息（题库/课程）
        findOrderDetail() {
            this.setLoading(true);
            let params = {
                // courseid: this.$route.query.kmctype==8?this.$route.query.qid:(this.$route.query.kmctype==2?this.$route.query.reportid:(this.$route.query.kmctype==3?this.$route.query.liveid:this.$route.query.cid)),
                courseid:this.kmcinnerid,
                // kmctype:this.$route.query.kmctype==8?8:(this.$route.query.kmctype==2?2:(this.$route.query.kmctype==3?3:7)),
                kmctype:this.kmctype,
            };
            getOrderDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false);
                    this.tableData = [data.data]
                    if (data.data.couponvoucherlist.length) {
                        this.discountPrice = data.data.couponvoucherlist[0].discountmoney
                        this.saleprice = data.data.couponvoucherlist[0].ordermoney
                        this.selectCouponIndex = 0
                    } else {
                        this.selectCouponIndex = -1
                        this.saleprice = data.data.finalpayprice
                    }
                },
                error: data => {
                    // console.log('error：', data);
                    this.setLoading(false);
                    this.$message.error(data.msg)
                }
            })
        },
        openFormDialog() {
            this.$refs.formDialog.open(this.tableData[0].formlist)
        },
        // 提交订单
        submitOrder() {
            if (this.tableData[0].isform && !this.fillInForm) {
                this.openFormDialog()
            } else {
                if (this.agreement) {
                    this.setLoading(true);
                    // console.log(this.saleprice)
                    let resulturl=''
                    //2 报告 3直播 7课程 8题库
                    if(this.kmctype==2){//报告
                        resulturl='http://report.capwhale.com/orderbr?'
                    }
                    else if(this.kmctype==3){//直播
                        resulturl='http://live.capwhale.com/orderbr?'
                    }
                    else if(this.kmctype==7){//课程
                        resulturl='http://ke.capwhale.com/orderbr?'
                    }
                    else if(this.kmctype==8){//题库
                        resulturl='http://ke.capwhale.com/orderbr?'
                    }
                    resulturl+='kmcinnerid='+this.kmcinnerid+"&kmctype="+this.kmctype
                    let params = {
                        // kmctype: this.$route.query.kmctype==8?8:(this.$route.query.kmctype==2?2:7),
                        // courseid: this.$route.query.kmctype==8?this.$route.query.qid:(this.$route.query.kmctype==2?this.$route.query.reportid:this.$route.query.cid),
                        kmctype:this.kmctype,
                        courseid:this.kmcinnerid,
                        ordermoney: this.tableData[0].finalpayprice,
                        paymoney: this.saleprice,
                        // channelid: this.channelid,
                        // resulturl: this.$route.query.kmctype===8?`http://ke.capwhale.com/orderbr?qid=${this.$route.query.qid}`:`http://ke.capwhale.com/orderbr?cid=${this.$route.query.cid}`
                        // resulturl: this.$route.query.kmctype==='8'?`http://ke.capwhale.com/orderbr?qid=${this.$route.query.qid}`:
                        //     (this.$route.query.kmctype==='2'?`http://ke.capwhale.com/orderbr?reportid=${this.$route.query.reportid}`:`http://ke.capwhale.com/orderbr?cid=${this.$route.query.cid}`),
                        resulturl:resulturl,
                        couponinnerid: this.selectCouponIndex !== -1 ? this.tableData[0].couponvoucherlist[this.selectCouponIndex].couponvoucherid : '',
                        discountmoney: this.selectCouponIndex !== -1 ? this.discountPrice : '',
                        userformlist: JSON.stringify(this.fillInArr),
                        channelid: this.$route.query.chid ? this.$route.query.chid : ''
                    };
                    uploadPayOrder({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false)
                            if(data.code === '000') {
                                if (data.data.ispaysuccess) {
                                    if (this.kmctype === 8 || this.kmctype === '8') {
                                        this.$router.push({name: 'QuestionDetails', query: {qid: this.kmcinnerid}})
                                    } else if(this.kmctype === 2 || this.kmctype === '2'){ //报告
                                        this.$router.push({name: 'ReportDetails', query: {reportid: this.kmcinnerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                                    } else if (this.kmctype === 3 || this.kmctype === '3') { // 直播
                                        this.$router.push({name: 'VideoLiveing', query: {innerid: this.kmcinnerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                                    }else{ //课程
                                        this.$router.push({name: 'CourseDetails', query: {cid: this.kmcinnerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                                    }
                                } else {
                                    window.location.replace(data.data.url)
                                }
                            } else if(data.code === '200') {
                                this.repeatOrder(data.data.orderno)
                            }
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    this.$message.warning('请勾选《快捷支付协议》和《微信支付用户服务协议》')
                }
            }
        },
        // 重复订单
        repeatOrder(val) {
            this.setLoading(true)
            let params = {
                orderno: val,
                // resulturl: `${window.location.origin}/p/orderbr`
                resulturl: `http://ke.capwhale.com/orderbr`
                // resulturl: this.$route.query.kmctype===8?`http://ke.capwhale.com/p/orderbr?qid=${this.$route.query.qid}`:`http://ke.capwhale.com/p/orderbr?cid=${this.$route.query.cid}`
            }
            getPayResultInfo({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log(data.data)
                    window.location.replace(data.data.url)
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(
            ['loginPop', 'user', 'channelid']
        )
    },
    components: {
        FormDialog
    }
}
</script>

<style lang="scss" type="text/scss">
.OrderIndex {
    // min-height: 200px;
    // padding-top: 80px;
    // margin-top: 80px;
    .warp {
        font-family:PingFangSC-Medium,PingFang SC;
        color: #333;
        width: 1200px;
        padding: 0 10px;
        // background-color: pink;
        box-sizing: border-box;
        margin: 0 auto;
        .order_info_text {
            padding-top: 30px;
            padding-bottom: 20px;
            font-size:16px;
            font-weight: bold;
            line-height:22px;
        }
        .order_info_box {
            .p_title {
                line-height:20px;
                font-size:14px;
                padding-left: 8px;
                border-left: 2px solid #409EFF;
                margin-bottom: 20px;
            }
            .pay_text {
                line-height:20px;
                &>span {
                    color: #FF4747FF;
                    font-size: 18px;
                }
                &.coupon {
                    span {
                        color: #333333;
                        font-size: 14px;
                    }
                    margin-bottom: 12px;
                }
            }
            .exchange_tips {
                font-size: 14px;
                color: #409EFF;
                padding-top: 20px;
                cursor: pointer;
            }
            .submit_order_box {
                padding-top: 60px;
                padding-bottom: 80px;
                // display: flex;
                // justify-content: center;
                text-align: center;
                .el-button {
                    margin: auto;
                }
                .agreementBox {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-top: 20px;
                    color: #9DA4AF;
                    font-size: 12px;
                    .el-checkbox {
                        height: 14px;
                        margin-right: 5px;
                    }
                    a {
                        color: #409EFF;
                        cursor: pointer;
                    }
                }
            }
            .table_box {
                margin-bottom: 50px;
                .el-table th, .el-table .has-gutter tr {
                    background-color: #F5F5F5;
                    color: #333;
                    font-size:14px;
                }
                .table_course_name_box {
                    display: flex;
                    align-items: center;
                    &>img {
                        width:124px;
                        height:70px;
                        border-radius:4px;
                        margin-right: 20px;
                    }
                    &>span {
                        width: 256px;
                        line-height:20px;
                        font-size:14px;
                        text-align: left;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
            }
            .couponCode {
                box-shadow: none;
                margin-bottom: 20px;
                border-color: #E5E5E5;
                .el-tabs__nav-scroll {
                    background: #F5F5F5;
                    .is-active {
                        color: #333333;
                    }
                    .el-tabs__item:hover {
                        color: #333333;
                    }
                }
                .el-tabs__content {
                    // padding: 10px;
                }
                .content {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    max-height: 284px;
                    overflow-y: scroll;
                    .item {
                        padding: 16px 12px 18px;
                        background: #FEF6EF;
                        border-radius: 6px;
                        width: 214px;
                        box-sizing: border-box;
                        margin-bottom: 20px;
                        position: relative;
                        cursor: pointer;
                        &:not(:nth-of-type(5n)) {
                            margin-right: 15px;
                        }
                        .faceprice_preferContent {
                            color: #FE666D;
                            display: flex;
                            align-items: flex-end;;
                            margin-bottom: 4px;
                            .faceprice {
                                // font-size: 18px;
                                vertical-align: bottom;
                                // line-height: 25px;
                                .faceprice, .voucherdisrate {
                                    font-weight: bold;
                                    font-size: 24px;
                                    vertical-align: bottom;
                                    line-height: 22px;
                                }
                                .unit {
                                    font-size: 14px;
                                    // line-height: 30px;
                                }
                            }
                            .preferContent {
                                font-size: 14px;
                                // line-height: 30px;
                                margin-left: 4px;
                            }
                        }
                        .date {
                            font-size: 12px;
                            color: #9DA4AF;
                        }
                        &.active {
                            border: 1px solid #FF4747;
                        }
                        .select {
                            width: 22px;
                            height: 20px;
                            position: absolute;
                            right: 0;
                            bottom: 0;
                        }
                    }
                }
                .code {
                    display: flex;
                    .el-input {
                        width: 308px;
                        margin-right: 12px;
                        height: 32px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-button {
                        width: 58px;
                        height: 32px;
                        padding: 0;
                        line-height: 32px;
                    }
                }
            }
        }
    }
    .exchangeDialog {
        .el-dialog__header {
            // padding: 0;
        }
        .el-dialog__body {
            .el-input {
                height: 34px;
                .el-input__inner {
                    height: 34px;
                }
            }
        }
        .el-dialog__footer {
            padding-top: 0;
            text-align: center;
            .el-button {
                height: 32px;
                width: 58px;
                padding: 0;
            }
            .el-button--primary {
                margin-left: 20px;
            }
        }
    }
}
</style>